<template>
  <div>
    <nav-breadcrumb :menu="[{label: '还款记录查询'}]"/>
    <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>


  </div>
</template>

<script>
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  import xhr from '../../utils/xhr'
    export default {
        name: "FinancingRepaymentList",
      data(){
        return{
          tableData: {
            count: 0,
            data: []
          },
          page: 1,
          pageSize: 20,
          actions: [
            {
              label: '导出',
              clickHandler:()=>{
                let routeData = this.$router.resolve({
                  path: '/ix/fang/financing/Repayment.List?format=xlsx',
                  query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
                });
                window.open(routeData.href.replace('#/', '/'), '_blank');
              }
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              u__customerName:'',
              cj__channel:'',
              rex__repayDate:'',
              fi__transactionNo:'',
              u__customerContactNo:'',
            },
            columns: [
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',

              },
              {
                label: '还款方式',
                component: 'el-input',
                field: 'cj__channel',

              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'u__customerName',

              },

              {
                label: '应还款日',
                component: 'date-range-picker',
                field: 'plan__repayDate',
                op: ['gteq', 'lteq'],
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '还款方式',
              field: 'cj__channel'
            },
            {
              label: '实还款日',
              field: 'rex__repayDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },

            {
              label: '客户姓名',
              field: 'u__customerName'
            },
/*            {
              label: '还款期号',
              field: 'rex__sequenceNo'
            },
            {
              label: '到期日',
              field: '',
             /!* formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }*!/
            },*/
            {
              label: '应还款日',
              field: 'plan__repayDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '还款账户',
              field: 'cj__outboundAccountDesc'
            },
            {
              label: '收款账户',
              field: 'cj__inboundAccountDesc'
            },
            {
              label: '应还金额',
              field: 'plan__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '本金',
              field: 'rex__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '利息',
              field: 'rex__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            /*{
              label: '服务费',
              field: 'rex__lendingFeeAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/

            {
              label: '实际还款金额',
              field: 'rex__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '备注',
              field: 're__remarks'
            }
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.sort.dataField': 'fi.transactionDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },

      watch: {
        filterParams: function () {
          this.getData()
        },
      },

      mounted() {
        this.getData()
      },
      methods: {
        getData: function () {
          xhr.getFinancingRepaymentList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.tableData = res.data
              } catch (e) {

              }
            })
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FinancingRepaymentList.vue